/**
 * Online Ordering Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum PromotionStatus {

    Active = 'active',

    Inactive = 'inactive',

    Scheduled = 'scheduled',

    Expired = 'expired',

    BudgetReached = 'budget_reached'
}

